import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { MessageService } from 'primeng/api';
import { LocationService } from 'src/app/location.service';
import { Location } from 'src/app/models/location';
import { MasterData } from 'src/app/models/masterdata';
import { MasterDataService } from 'src/app/shared/master-data.service';

@Component({
  selector: 'app-new-location',
  templateUrl: './new-location.component.html',
  styleUrls: ['./new-location.component.scss']
})
export class NewLocationComponent implements OnInit {
  title = '';
  canCreate = false;
  closeBtnName = '';
  counties: Map<string, MasterData> = new Map();
  countiesRelation: Map<string, string[]> = new Map();
  subCountiesRelation: Map<string, string> = new Map();
  subCounties: Map<string, MasterData> = new Map();
  filteredSubCounties: Map<string, MasterData> = new Map();
  locations: Array<any> = [];
  filteredLocations: Array<any> = [];
  filter: Location = { city: '', county: '', countyName: '', name: '', street: '', sub_county: '', sub_countyName: '', zip: '' };

  countiesFilter = ['BTV', '* anderer Verband', 'Oberbayern', 'Niederbayern', 'Oberpfalz', 'Oberfranken', 'Mittelfranken', 'Unterfranken', 'Schwaben'];

  constructor(public bsModalRef: BsModalRef, private masterDataService: MasterDataService,
    private locationService: LocationService,
    private messageService: MessageService,
    private cdr: ChangeDetectorRef,
  ) {
    // Oberbayern
    this.countiesRelation.set('AE2BC983-0335-4EDB-9DCC-C2F64A0C4FC0', [
      '6D095CED-6EF6-4E28-9FA0-701A73B2D3F2',
      'C86954AE-5B14-40C9-9F75-6EFA8B88629C',
      '3843A6B3-1426-45DC-ABC6-95AF2F688C68',
      '97A26FCB-B918-411A-857E-ACC6A55965A8',
      '4E770BF3-A2DD-47B9-A6AA-ABBDEE0243A6',
      'EEB5ABFA-2814-4A78-8264-06FF0E79A853',
    ]);

    // Niederbayern
    this.countiesRelation.set('7F41D860-14AE-40CE-913E-E62CAD104063', [
      'EE5E8695-D864-4D3F-99E6-8F60A0EA31AD',
      '66294CCE-CE80-4FBC-84BA-217AA336E7BB',
      'D0D84E8D-2655-4A41-8F55-A6D58A71EF92',
    ]);

    // Oberpfalz
    this.countiesRelation.set('F68567CE-6117-4BF2-AB97-7ADC22CB8A60', [
      '61C5777A-391B-4D6D-9B33-87C92386C107',
      'BF0AA2A8-AC85-410A-A7C4-86F666617EE5',
    ]);

    // Oberfranken
    this.countiesRelation.set('B818DB82-A8D9-4A3F-A65C-EE2B69DF328E', [
      '6259AB02-ED1A-4AFA-A1CD-AF96D5459A85',
      '2356C7A2-6F8B-487E-BE24-01A993627D67',
      '96B1E765-8DA4-48E6-BEA6-F1603679FD14',
      '53B32A2E-5567-409C-9948-ED38F82D30C6',
    ]);

    // Mittelfranken
    this.countiesRelation.set('972B70A3-791C-4435-AAE1-9B2490BDE5E4', [
      '7F8C437C-492D-4004-9756-A867D7BAC57F',
      '198A5540-D03F-4B7A-B3BF-9EDAEBFD227C',
      '6FD3D5A8-85BE-410D-B6B7-C5A656DEC9B2'
    ]);

    // Unterfranken
    this.countiesRelation.set('53D68B04-C9E6-4A9C-9711-397A2F335488', [
      'E90E5796-88D8-4ED8-90CD-CB0AB9E87164',
      '5B35649B-C29F-415D-A104-951FD2319CFB',
      '07456AC5-5402-4702-935F-EF113E5DD9EA',
      '38868FAA-045A-4B11-BEB3-4D19B0957069',
    ]);

    // Schwaben
    this.countiesRelation.set('9355C5BD-3759-4956-81C9-2E0325570C89', [
      '5307EF60-64B8-4BB5-9476-9BE7A3316951',
      'B151A024-E257-43B4-9F46-6A8D4DCF93E8',
      'D29B7ACD-C23D-447F-A09B-B4BC1FD7914A',
      '5D5EA260-C397-4938-B7F6-81E38A079FE2',
    ]);

    for (const key of this.countiesRelation.keys()) {
      const subCounties = this.countiesRelation.get(key);
      if (subCounties) {
        subCounties.forEach((county) => this.subCountiesRelation.set(county, key));
      }
    }
  }

  ngOnInit(): void {
    this.masterDataService.getLocations().then((locations) => {
      this.locations = locations;
    });

    this.masterDataService.getCounties().then((counties) => {
      counties.forEach((item) => {
        if (this.countiesFilter.includes(item.name)) {
          this.counties.set(item.id, item);
        }
        else {
          this.subCounties.set(item.id, item);
        }
      });

      this.filteredSubCounties = new Map(this.subCounties);
    });
  }

  update() {
    let locations = [...this.locations];

    if (this.filter.zip.length > 2) {
      locations = locations.filter((location) => location.zip.includes(this.filter.zip));
    }

    if (this.filter.city.length > 2) {
      const city = this.filter.city.toLocaleLowerCase();
      locations = locations.filter((location) => location.city.toLocaleLowerCase().includes(city));
    }

    if (this.filter.street.length > 2) {
      const street = this.filter.street.toLocaleLowerCase();
      locations = locations.filter((location) => location.street.toLocaleLowerCase().includes(street));
    }

    if (this.filter.name.length > 2) {
      const name = this.filter.name.toLocaleLowerCase();
      locations = locations.filter((location) => location.name.toLocaleLowerCase().includes(name));
    }

    if (this.filter.county) {
      locations = locations.filter((location) => location.county === this.filter.county);
    }

    if (this.filter.sub_county) {
      locations = locations.filter((location) => location.sub_county === this.filter.sub_county);
    }

    this.filteredLocations = locations.slice(0, 9);
    this.filteredLocations.forEach((item) => {
      item.countyName = this.counties.get(item.county)?.name;
      item.sub_countyName = this.subCounties.get(item.sub_county)?.name;
    });

    this.canCreate = this.filteredLocations.length === 0
      && this.filter.zip.length === 5
      && this.filter.city.length !== 0
      && this.filter.street.length !== 0
      && this.filter.name.length !== 0
      && this.filter.county.length !== 0
      && this.filter.sub_county.length !== 0;

    this.cdr.detectChanges();
  }

  updateCounty() {
    this.filterSubCountyList();
    this.update();
  }

  updateSubCounty(value: string) {
    const county = this.subCountiesRelation.get(value);

    if (county && (!this.filter.county || county !== this.filter.county)) {
      this.filter.county = county;
    }

    this.filter.sub_county = value;
    this.cdr.detectChanges();

    this.update();
  }

  private filterSubCountyList() {
    const subCounties = this.countiesRelation.get(this.filter.county);
    this.filter.sub_county = '';
    if (subCounties) {
      this.filteredSubCounties.clear();
      subCounties.forEach((county) => {
        const data = this.subCounties.get(county);
        if (data) {
          this.filteredSubCounties.set(county, data);
        }
      });
    }
  }

  create() {
    this.locationService.addLocationData(this.filter).subscribe((response) => {
      console.log('addLocationData returned:', response);
      this.bsModalRef.hide();
      this.masterDataService.clearLocations();
      this.masterDataService.getLocations().then((locations) => {
        this.locations = locations;
      });
      if (response?.message === 'new location saved') {
        this.messageService.add({
          detail: 'Neuen Lehrgangsort angelegt und Liste der Orte neu geladen.',
          summary: 'Lehrgangsort angelegt',
          severity: 'success'
        });
      }
    },
      (error) => {
        console.error(error);
        this.messageService.add({
          detail: 'Lehrgangsort konnte nicht angelegt werden',
          summary: 'xxx',
        })
      });
  }

}
